import React from "react";
import Card from "react-bootstrap/Card";
import CardDeck from "react-bootstrap/CardDeck";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { skills } from "./skills-data";

import "./skills.styles.css";

const SkillCard = ({ title, items }) => (
  <Card className="focus mt-2 mb-2">
    <Card.Body>
      <Card.Title className="text-center card-title">{title}</Card.Title>
      <hr />
      <Card.Text as="div" className="card-text d-flex justify-content-start flex-column">
        {items.map((skill) => (
          <span className="p-2" key={skill.skillName}>
            <a
              className="text-dark text-decoration-none"
              href={skill.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={skill.imgSrc}
                alt={skill.imgAltText}
                rounded
                className="image-style m-1"
              ></Image>{" "}
              {skill.skillName}
            </a>
          </span>
        ))}
      </Card.Text>
    </Card.Body>
  </Card>
);

const columns = [
  [
    { title: "Frontend", items: skills.frontend },
    { title: "DevOps & Tools", items: skills.devOps },
  ],
  [
    { title: "Backend", items: skills.backend },
    { title: "Cloud & Deployment", items: skills.cloudDeployment },
  ],
  [
    { title: "Languages", items: skills.programmingLanguages },
    { title: "Real-time & Integrations", items: skills.realTime },
    { title: "Also Working With", items: skills.alsoWorkingWith },
  ],
];

const Skills = () => {
  return (
    <div className="pt-3 pb-3">
      <h1 className="text-center font-details-b pb-4">TECH SKILLS</h1>
      <CardDeck>
        <Row className="d-flex justify-content-around">
          {columns.map((cards, i) => (
            <Col md={4} key={i}>
              {cards.map((card) => (
                <SkillCard key={card.title} title={card.title} items={card.items} />
              ))}
            </Col>
          ))}
        </Row>
      </CardDeck>
    </div>
  );
};

export default Skills;
